import React from 'react';
import ReactPlayer from 'react-player';
import { Box } from '@mui/material';

interface VideoPlayerProps {
  url: string;
  videoHeight?: string;
  containerWidth?: string;
  sxProps?: any;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  url,
  videoHeight = '530px',
  containerWidth = '300px',
  sxProps = {},
}) => {
  return (
    <Box
      sx={{
        width: containerWidth,
        height: videoHeight,
        ...sxProps,
      }}
    >
      <ReactPlayer
        url={url}
        controls
        width="100%"
        height={videoHeight}
        config={{
          file: {
            attributes: {
              style: {
                width: '100%',
                height: videoHeight,
              },
            },
          },
        }}
      />
    </Box>
  );
};

export default VideoPlayer;
